import { hexToRgba } from './convert';
import { ObjectColor } from '../types';

export const equalColorObjects = (first: ObjectColor, second: ObjectColor): boolean => {
  if (first === second) return true;

  for (const prop in first) {
    // The following allows for a type-safe calling of this function (first & second have to be HSL, HSV, or RGB)
    // with type-unsafe iterating over object keys. TS does not allow this without an index (`[key: time]: number`)
    // on an object to define how iteration is normally done. To ensure extra keys are not allowed on our types,
    // we must cast our object to unknown (as RGB demands `r` be a key, while `Record<time, x>` does not care if
    // there is or not), and then as a type TS can iterate over.
    if ((first as unknown as Record<string, number>)[prop] !== (second as unknown as Record<string, number>)[prop])
      return false;
  }

  return true;
};

export const equalHex = (first: string, second: string): boolean => {
  if (first.toLowerCase() === second.toLowerCase()) return true;

  // To compare colors like `#FFF` and `ffffff` we convert them into RGB objects
  return equalColorObjects(hexToRgba(first), hexToRgba(second));
}

export const equalColors = (first: string, second: string): boolean => {
	return first === second;
}

export const equalColorString = (first: string, second: string): boolean => {
	return first.replace(/\s/g, '') === second.replace(/\s/g, '');
}

export function findMaxDistanceAndMidpoint(positions: number[]): number {

	return (function findPoint(positions, min = 0, max = 1){

		// Kiểm tra tính hợp lệ của đầu vào

		if (!positions || positions.length < 1) {
			return 0
		}

		// Sắp xếp danh sách vị trí theo thứ tự tăng dần
		positions.sort((a, b) => a - b);

		// Xác định điểm đầu và điểm cuối
		const firstPoint = positions[0];
		const lastPoint = [...positions].pop();

		// Khởi tạo biến để lưu khoảng cách và điểm giữa
		let maxDistance = 0;
		let midpoint = 0;
		let distance = 0;

		// Duyệt qua danh sách vị trí
		for (let i = 1; i < positions.length; i++) {
			const currentPoint = positions[i];
			const previousPoint = positions[i - 1];

			// Tính khoảng cách giữa điểm hiện tại và điểm trước đó
			distance = currentPoint - previousPoint;

			// Cập nhật khoảng cách lớn nhất và điểm giữa nếu cần thiết
			if (distance > maxDistance) {
				maxDistance = distance;
				midpoint = (currentPoint + previousPoint) / 2;
			}
		}

		// Xác định điểm thứ 2 nếu chỉ có 1 điểm
		if (positions.length === 1) {
			midpoint = firstPoint === 0 ? 1 : 0;
		}

		distance = max - lastPoint;

		if(!positions.includes(max) && distance > maxDistance){
			maxDistance = distance;
			midpoint = max;
		}

		distance = firstPoint;

		if(!positions.includes(min) && distance > maxDistance){
			midpoint = min;
		}

		// Trả về kết quả
		return midpoint
	})(positions)
}



export async function saveColor(color:string): Promise<void>{
	let c: any = [], type = color?.includes('gradient') ? 'gradientColors' : 'defaultColors';

	let colors: string[] = [];
	colors.push(color);

	try{
		c = await getItem(type);
		c = JSON.parse(c) || [];
		c.map((v: any, idx: number) =>{
			if(!colors.includes(v) && idx < 24){
				colors.push(v)
			}
		})
	}catch (e) {
		debug(e)
	}
	await setItem(type, JSON.stringify(colors));
}